import logoEgam from "../../assets/images/logo-egam-login.png";
import {
  Container,
  Card,
  Logo,
  Title,
  Subtitle,
  Button,
  Divider,
} from "./styles";

const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 19l-7-7m0 0l7-7m-7 7h18"
    />
  </svg>
);

const getEgamUrl = () => {
  const apiUrl = process.env["REACT_APP_URL_EGAM_API"] || "";
  return apiUrl.substring(0, apiUrl.length - 9);
};

const Unauthorized = () => (
  <Container>
    <Card>
      <Logo src={logoEgam} alt="eGAM" />

      <Title>Sessão não autorizada</Title>

      <Divider />

      <Subtitle>
        Sua sessão expirou ou você não possui permissão para acessar esta
        página. Por favor, retorne ao eGAM e faça login novamente.
      </Subtitle>

      <Button href={getEgamUrl()}>
        <ArrowIcon />
        Voltar ao eGAM
      </Button>
    </Card>
  </Container>
);

export default Unauthorized;
